import React, { useContext, useEffect } from "react"
import * as context from "./context"

interface props {
	enabled: boolean
}

export default function Empty(props: React.PropsWithChildren<props>): JSX.Element {
	const { children, enabled } = props

	const { increment } = useContext(context.Context)

	useEffect(() => {
		increment(enabled ? 1 : -1)
	}, [enabled, increment])

	return enabled ? <>{children}</> : <></>
}
